import { defineComponent as _defineComponent } from 'vue'
import Password from "primevue/password";
import Checkbox from "primevue/checkbox";
import {Field, Form} from "vee-validate";
import {object} from "yup";
import * as Yup from "yup";
import {ref} from "vue";
import {useUserServiceStore} from "@/store/userService.store";
import {useRoute, useRouter} from "vue-router";
import {useToast} from "vue-toastification";
import {pattern} from "@/utils/passwordPattern";



export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpView',
  setup(__props, { expose: __expose }) {
  __expose();


const schema = object().shape({
  email:  Yup.string()
    .required( "This field is required"),
  password:  Yup.string()
    .required( "This field is required")
    .matches(pattern,'FORMS.VALIDATION_ERRORS.PASSWORD_REGEX' ),
  passwordRetype: Yup.string().required("This field is required").oneOf([Yup.ref('password'), null], "Passwords don't match"),
  termsAccepted: Yup.bool().oneOf([true], "This field is required")
});


const email = ref<string>();
const password = ref<string>();
const passwordRetype = ref<string>();
const termsAccepted = ref<boolean>(false);

function register(){

  if(email.value && password.value) {
    useUserServiceStore().createEmailAccount( { login:email.value, password:password.value  }, onSuccessEmailSend);

  }
}

const router = useRouter();
const toast = useToast();
const onSuccessEmailSend = () => {
  toast.success('The message has been sent to the e-mail address provided');
  router.push({name: 'activate'});
};



const __returned__ = { schema, email, password, passwordRetype, termsAccepted, register, router, toast, onSuccessEmailSend, get Password() { return Password }, get Checkbox() { return Checkbox }, get Field() { return Field }, get Form() { return Form }, get useRoute() { return useRoute } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})